<script>
    export default {
        props: {
            logs: {
                type: Array,
                required: true
            }
        }
    }
</script>

<template>
    <div class="changelog">
        <h1 class="title mt-3">{{ $vuetify.lang.t('$vuetify.drawer.changelog') }}</h1>

        <VTimeline dense>
            <VTimelineItem
                v-for="(item, i) in logs"
                :key="i"
                :color="item.color"
                :icon="item.icon"
                small
                fill-dot>
                <span slot="opposite">{{ item.date }}</span>
                <VCard :color="item.color" dark>
                    <VCardTitle>
                        <div class="title flex">{{ item.version }}</div>
                        <div class="subtitle-1">{{ item.date }}</div>
                    </VCardTitle>

                    <VCardText class="white black--text">
                        <p v-show="item.text">{{ item.text }}</p>
                        <ul v-show="item.list.length > 0" class="pt-2">
                            <li v-for="(content, ic) in item.list" :key="ic">{{ content }}</li>
                        </ul>
                    </VCardText>

                    <VCardActions v-show="item.href" class="white">
                        <VBtn :color="item.color" class="mx-0" outlined>
                            Mehr...
                        </VBtn>
                    </VCardActions>
                </VCard>
            </VTimelineItem>
        </VTimeline>
    </div>
</template>

<style lang="scss" scoped>
    .changelog {
        padding: 12px 24px;
    }
</style>
